import request from '@/API/request';

// 废品大类获取所有列表
export function getWasteTypeAll() {
  return request({
    url: "resource/api/waste/category/list",
    method: "get",
  });
}

// 获取废品子类置顶数据
export function getWasteTypeTopList() {
  return request({
    url: "resource/api/waste/subcategory/top/subcategory",
    method: "get",
  });
}

// 废品子类详情
export function getWasteSubDetail(id) {
  return request({
    url: `resource/api/waste/subcategory/${id}`,
    method: "get",
  });
}

// 所有废品子类
export function getWasteSubList(params) {
  return request({
    url: "resource/api/waste/category/subcategory/statistics",
    method: "get",
    params
  });
}


// 通过日期范围获取子类的价格趋势接口
export function getWasteSubTrend(subcategoryId,params) {
  return request({
    url: `resource/api/waste/subcategory/range/subcategory/${subcategoryId}/trend`,
    method: "get",
    params
  });
}

// 根据版本号查询历史价格上报具体数据
export function getVersionReport(version) {
  return request({
    url: `resource/api/waste/category/associated/data/${version}`,
    method: "get",
  });
}

// 上报价格
export function createPrice(data) {
  return request({
    url: "resource/api/report/price",
    method: "post",
    data
  });
}

// 获取当前企业账号上报的价格数据结构
export function getCurrentPrice() {
  return request({
    url: "resource/api/waste/category/associated/data",
    method: "get",
  });
}

// 获取当前企业账号上报的历史数据
export function getHistoryReport() {
  return request({
    url: "resource/api/waste/category/associated/list",
    method: "get",
  });
}

// 导入企业价格数据
export function importPriceDate(reportDate, file) {
  return request({
    url: `resource/api/data/price/import?reportDate=${reportDate}`,
    method: "post",
    data:file
  });
}


// 所有类别价格趋势
export function getAllCategoryTrend() {
  return request({
    url: "resource/api/report/price/trend/all",
    method: "get",
  });
}

// 子类价格趋势
export function getSubCategoryTrend(subcategoryId, data = {}) {
  return request({
    url: `resource/api/report/price/trend/subcategory`,
    method: "get",
    params:{
      subcategoryId,
      ...data
    }
  });
}














// 废品子类获取所有列表get 
export function getWasteSubListAll() {
  return request({
    url: "resource/api/waste/subcategory/list",
    method: "get",
  });
}

// 删除某一个废品子类
export function deleteWasteSub(id) {
  return request({
    url: `resource/api/waste/subcategory/${id}`,
    method: "delete",
  });
}

// 创建废品子类价格
export function createSubPrice(data) {
  return request({
    url: "resource/api/waste/price/history",
    method: "post",
    data
  });
}

// 编辑修改废品子类价格管理
export function updateSubPrice(data) {
  return request({
    url: "resource/api/waste/price/history",
    method: "put",
    data
  });
}

// 所有废品价格查询
export function getAllSubPrice() {
  return request({
    url: "resource/api/waste/price/history/page",
    method: "get",
  });
}

// 删除废品价格
export function deleteSubPrice(id) {
  return request({
    url: `resource/api/waste/price/history/${id}`,
    method: "delete",
  });
}
